import { API } from '../../../utils/Helper';
import React, { useState } from 'react'
import { Link, useHistory } from "react-router-dom";
import { withCookies } from "react-cookie";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const FullScreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: #1b2336;
`;

const FullScreenIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: ${(props) => (props.loading ? "none" : "block")};
`;

const BackButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
`;

const GameCards = ({ cookies }) => {
  const navigate = useHistory();
  const [loading, setLoading] = useState(false);
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const [iframeLoading, setIframeLoading] = useState(true);
  const [message, setMessage] = useState(null);

  const handleRedirect = (path) => {
    navigate.push(path);
  };

  const handleGameLaunchWB = async () => {
    setLoading(true);
    setMessage(null);

    try {
      const uid = cookies.get("uid");

      // Baccarat C game data from your selection
      const game = {
    "prd_name": "Evolution Asia",
    "prd_category": "Live Casino",
    "game_id": 258,
    "game_name": "MONOPOLY Live",
    "table_id": null,
    "game_type": "Monopoly",
    "is_enabled": 1
  };

      // Create the correct prd object format matching ApiGame.js
      const categoryId = "1"; // Evolution Asia category ID
      let prd = {
        id: categoryId,
        type: 0,
        table_id: game.table_id,
        is_mobile: 0,
      };

      if (!uid) {
        setMessage({ type: "error", text: "Please login to play games" });
        setLoading(false);
        return;
      }

      const response = await fetch(`${API}/authWBGames`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_code: String(uid),
          prd,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to launch game");
      }

      const result = await response.json();
      console.log(result, "result");

      if (result.data) {
        setIframeUrl(result.data.launch_url || result.data);
        setShowIframe(true);
        setIframeLoading(true);
      } else {
        setMessage({ type: "error", text: "Failed to get game URL" });
      }
    } catch (error) {
      setMessage({ type: "error", text: error.message });
    } finally {
      setLoading(false);
      setTimeout(() => {
        setMessage(null);
      }, 5000);
    }
  };

  const handleBackButton = () => {
    setShowIframe(false);
    setIframeUrl("");
    setIframeLoading(true);
    window.location.href = "/";
  };

  const handleIframeLoad = () => {
    setIframeLoading(false);
  };
  // Show fullscreen game if iframe is active
  if (showIframe) {
    const imageStyle = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "250px",
      animation: "fadeinout 2s infinite",
    };

    const animationStyle = `
      @keyframes fadeinout {
        0%, 100% { opacity: 0; }
        50% { opacity: 1; }
      }
    `;

    return (
      <FullScreenContainer>
        <style>{animationStyle}</style>
        {iframeLoading && (
          <img src="/assets/gloader.png" alt="Loading" style={imageStyle} />
        )}
        <FullScreenIframe
          src={iframeUrl}
          title="Baccarat C Game"
          onLoad={handleIframeLoad}
          loading={iframeLoading}
        />
        <BackButton onClick={handleBackButton}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </BackButton>
      </FullScreenContainer>
    );
  }

  const rawCards = window?.siteConfig?.game_cards;
  const cards = typeof rawCards === 'string' ? JSON.parse(rawCards) : (rawCards || []);

  const displayCards = cards.length >= 6 ? cards : [
    { id: "card-1", name: "Casino", action_type: "launch_game", path: "", bg_image: "/assets/bcimages/bchome/casino-game-card.webp", icon: "/assets/bcimages/bchome/casino-home-gamecard.svg", desc: "Casino" },
    { id: "card-2", name: "SPORTS", action_type: "redirect", path: "/casino/sports", bg_image: "/assets/bcimages/bchome/sports-game-card.webp", icon: "/assets/bcimages/bchome/sports-home-gamecard.svg", desc: "Bet on Football, Cricket, NFL, eSports & over 80 sports!" },
    { id: "card-3", name: "SPRIBE", action_type: "redirect", path: "/providers/300", bg_image: "/assets/images/bccrash.png", icon: "/assets/bcimages/bchome/lottery-home-gamecard.svg", desc: "" },
    { id: "card-4", name: "LIVE", action_type: "redirect", path: "/casino", bg_image: "/assets/images/live-card.png", icon: "/assets/bcimages/bchome/racing-home-gamecard.svg", desc: "" },
    { id: "card-5", name: "SLOTS", action_type: "redirect", path: "/casino/slots", bg_image: "/assets/images/bcslots.png", icon: "/assets/bcimages/bchome/updown-home-gamecard.svg", desc: "" },
    { id: "card-6", name: "EZUGI", action_type: "redirect", path: "/casino/live-casino", bg_image: "/assets/images/ezugi-live.png", icon: "/assets/bcimages/bchome/bingo-home-gamecard.svg", desc: "" }
  ];

  const grid1Cards = displayCards.slice(0, 2);
  const grid2Cards = displayCards.slice(2, 6);

  const getImagePath = (path) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    if (path.startsWith('/assets/')) return path;
    return path.startsWith('/') ? `${API}${path}` : path;
  };

  const handleCardClick = (card) => {
    if (card.action_type === 'launch_game') {
      handleGameLaunchWB();
    } else {
      handleRedirect(card.path);
    }
  };

  const getGradient = (idx) => {
    switch (idx) {
      case 1: return "linear-gradient(to left, rgb(80, 65, 48), transparent 75%)";
      case 2: return "linear-gradient(to left, rgb(45, 79, 49), transparent 75%)";
      case 3: return "linear-gradient(to left, rgb(71, 56, 111), transparent 75%)";
      default: return undefined;
    }
  };

  return (
    <div>
      {message && (
        <div className={`alert ${message.type === 'error' ? 'alert-error' : 'alert-success'} mb-4`}>
          {message.text}
        </div>
      )}
      <div className="homepage-game-cards">
        <div className="homepage-game-cards-grid-1">
          {grid1Cards.map((card, idx) => {
            const isFirst = idx === 0;
            return (
              <button
                key={card.id || idx}
                className={isFirst ? 'casino-home-gamecard' : 'sports-home-gamecard'}
                onClick={() => handleCardClick(card)}
                disabled={card.action_type === 'launch_game' && loading}
              >
                <img
                  className={isFirst ? 'casino-home-gamecard-img' : 'sports-home-gamecard-img'}
                  src={getImagePath(card.bg_image)}
                  alt={card.name}
                />
                <div className='casino-home-gamecard-contant'>
                  <div className='casino-home-gamecard-top'>
                    {card.icon && <img style={{ height: "2rem", width: "2rem", flex: "none" }} src={getImagePath(card.icon)} alt="icon" />}
                    <span className="text-sm ml-0.5 sm:text-2xl">
                      {card.action_type === 'launch_game' && loading ? "LOADING..." : card.name}
                    </span>
                  </div>
                  <div className="casino-home-gamecard-bottom">
                    {card.action_type === 'launch_game' && loading ? "Launching game..." : card.desc}
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        <div className='homepage-game-cards-grid-2'>
          {grid2Cards.map((card, idx) => {
            const style = getGradient(idx) ? { backgroundImage: getGradient(idx) } : undefined;
            return (
              <button
                key={card.id || idx}
                onClick={() => handleCardClick(card)}
                style={style}
                className='lottery-home-gamecard'
                disabled={card.action_type === 'launch_game' && loading}
              >
                <img className='lottery-home-gamecard-img' src={getImagePath(card.bg_image)} alt={card.name} />
                <div className='lottery-home-gamecard-span'>
                  {card.icon && <img style={{ height: "1.5rem", width: "1.5rem", flex: "none" }} src={getImagePath(card.icon)} alt="icon" />}
                  <span className="text-sm ml-0.5 sm:text-2xl">
                    {card.action_type === 'launch_game' && loading ? "LOADING..." : card.name}
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default withCookies(GameCards)
